import React from 'react'
import './styles.css'
const PageTitle = ({ children }) => {
    return (
        <h1 className="PageTitle">
            {children}
        </h1>
    )
}

export default PageTitle



// WEBPACK FOOTER //
// ./src/components/PageTitle/index.jsx